import { StyleSheet } from 'react-native';
import { themes } from '../../theme/theme';

export const styles = StyleSheet.create({
  label: {
    fontSize: 14,
    lineHeight: 32,
    fontWeight: 'bold',
  },
  labelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  requiredIndicator: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: 8,
  },
  iconContainer: {
    marginRight: 0,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: themes.light.gray_blue[6],
    borderTopLeftRadius: 7,
    borderBottomLeftRadius: 7,
    padding: 5,
    height: 40,
    width: 35,
  },
  iconImage: {
    width: 20, // Adjust this for the ideal size
    height: 11, // Adjust this for the ideal size
  },
  phoneCode: {
    marginRight: 4,
    fontSize: 16,
    color: themes.light.gray_blue[4],
  },
  input: {
    flex: 1,
    fontSize: 16,
    paddingVertical: 8,
    paddingHorizontal: 10,
  },
  flexInput: {
    flex: 3,
  },
  amountInput: {
    textAlign: 'left',
  },
  phoneContainer: {
    flex: 1,
    backgroundColor: themes.light.gray_blue[6],
    padding: 7,
  },
  phoneInput: {},
  flagContainer: {},
  flagText: {
    fontSize: 16,
    marginRight: 5,
  },
  phoneText: {
    color: themes.light.gray[1],
    fontSize: 16,
    paddingHorizontal: 10,
  },
  flagStyle: {
    width: 24,
    height: 24,
    resizeMode: 'contain',
    backgroundColor: themes.light.white[1],
  },
});
